export default __webpack_public_path__ + "static/media/stars 1.2c1fca1a.png";